export default "__VITE_ASSET__zlaxyIKu__"